import { render, staticRenderFns } from "./PortalViewCharts.vue?vue&type=template&id=4effb99c&scoped=true"
import script from "./PortalViewCharts.vue?vue&type=script&lang=ts"
export * from "./PortalViewCharts.vue?vue&type=script&lang=ts"
import style0 from "./PortalViewCharts.vue?vue&type=style&index=0&id=4effb99c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4effb99c",
  null
  
)

export default component.exports